import { Product, ProductOption } from '../types/types'

export const CATEGORIES = [
  'Sándwich',
  'Wrap',
  'Cremas',
  'Snack Bowl',
  'Niños',
  'Bebidas',
]

export const BOWL_OPTIONS: Record<string, ProductOption[]> = {
  bases: [
    { id: 'b1', name: 'Fideos de arroz', price: 1000 },
    { id: 'b2', name: 'Arroz blanco', price: 600 },
    { id: 'b3', name: 'Lechuga', price: 350 },
    { id: 'b4', name: 'Quinoa', price: 700 },
    { id: 'b5', name: 'Pasta tipo pluma de garbanzos', price: 700 },
    { id: 'b6', name: 'Mix de hojas verdes', price: 700 },
  ],
  proteinas: [
    { id: 'p1', name: 'Salmón', price: 2000 },
    { id: 'p2', name: 'Atún', price: 1800 },
    { id: 'p3', name: 'Camarón', price: 2000 },
    { id: 'p4', name: 'Pollo', price: 1200 },
  ],
  toppings: [
    { id: 't1', name: 'Hongos (tarro)', price: 400 },
    { id: 't2', name: 'Huevo duro', price: 400 },
    { id: 't3', name: 'Cebolla crujiente', price: 400 },
    { id: 't4', name: 'Maíz dulce', price: 400 },
    { id: 't5', name: 'Cebolla morada', price: 400 },
    { id: 't6', name: 'Tomate cherry', price: 400 },
    { id: 't7', name: 'Frijoles negros', price: 400 },
    { id: 't8', name: 'Chile dulce', price: 400 },
    { id: 't9', name: 'Garbanzo', price: 400 },
    { id: 't10', name: 'Zanahoria', price: 400 },
    { id: 't11', name: 'Plátano maduro', price: 400 },
    { id: 't12', name: 'Cebollín', price: 400 },
    { id: 't13', name: 'Pepino', price: 400 },
    { id: 't14', name: 'Palmito', price: 400 },
    { id: 't15', name: 'Mango', price: 400 },
    { id: 't16', name: 'Fresa', price: 400 },
    { id: 't17', name: 'Piña', price: 400 },
    { id: 't18', name: 'Crutones', price: 400 },
  ],
  toppingsPremium: [
    { id: 'tp1', name: 'Aguacate', price: 700 },
    { id: 'tp2', name: 'Pepinillos', price: 700 },
    { id: 'tp3', name: 'Queso mozzarella', price: 700 },
    { id: 'tp4', name: 'Edamames', price: 700 },
    { id: 'tp5', name: 'Hongos naturales', price: 700 },
  ],
  aderezos: [
    { id: 'a1', name: 'Aderezo de la casa', price: 200 },
    { id: 'a2', name: 'Vinagreta balsámica', price: 200 },
    { id: 'a3', name: 'Ranch', price: 200 },
    { id: 'a4', name: 'Mostaza miel', price: 200 },
    { id: 'a5', name: 'Aceite de oliva y limón', price: 200 },
  ],
  semillas: [
    { id: 's1', name: 'Ajonjolí', price: 200 },
    { id: 's2', name: 'Semillas varias', price: 200 },
  ],
}

export const MENU_PRODUCTS: Product[] = [
  {
    id: 'prod_sandwich',
    name: 'Sándwich',
    description:
      'Armá tu sándwich en la barra, incluye 4 toppings, pan ciabatta, aderezo a elegir y chips',
    price: 4000,
    category: 'Sándwich',
    customizable: true,
    type: 'sandwich',
  },
  {
    id: 'prod_wrap',
    name: 'Wrap',
    description:
      'Armá tu wrap en la barra, incluye 4 toppings, tortilla de trigo, aderezo a elegir y chips',
    price: 4000,
    category: 'Wrap',
    customizable: true,
    type: 'wrap',
  },
  {
    id: 'prod_crema_ayote',
    name: 'Crema de Ayote',
    description: 'Acompañadas de crutones y queso mozzarella',
    price: 2000,
    category: 'Cremas',
    type: 'crema',
  },
  {
    id: 'prod_crema_tomate',
    name: 'Crema de Tomate',
    description: 'Acompañadas de crutones y queso mozzarella',
    price: 2000,
    category: 'Cremas',
    type: 'crema',
  },
  {
    id: 'prod_snack_bowl',
    name: 'Snack Bowl',
    description: 'Smoothie bowl del día con frutas y toppings a elegir',
    price: 2900,
    category: 'Snack Bowl',
    customizable: true,
    type: 'snack_bowl',
  },
  {
    id: 'prod_ninos_pollo',
    name: 'Dedos de pollo',
    description:
      'Filetes de pollo ligeramente empanizados, servidos con chips y aderezo a elegir',
    price: 3500,
    category: 'Niños',
    type: 'ninos',
  },
  // Bebidas Naturales
  {
    id: 'beb_nat_agua_fresa',
    name: 'Natural en agua - Fresa',
    price: 1200,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_nat_agua_mora',
    name: 'Natural en agua - Mora',
    price: 1200,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_nat_agua_pina',
    name: 'Natural en agua - Piña',
    price: 1200,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_nat_agua_banano',
    name: 'Natural en agua - Banano',
    price: 1200,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_nat_leche_fresa',
    name: 'Natural en leche - Fresa',
    price: 1500,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_nat_leche_mora',
    name: 'Natural en leche - Mora',
    price: 1500,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_nat_leche_pina',
    name: 'Natural en leche - Piña',
    price: 1500,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_nat_leche_banano',
    name: 'Natural en leche - Banano',
    price: 1500,
    category: 'Bebidas',
    type: 'bebida',
  },
  // Smoothies
  {
    id: 'beb_smo_tropical',
    name: 'Smoothie tropical',
    description: 'piña y fresa',
    price: 1200,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_smo_berry',
    name: 'Smoothie Berry Mix',
    description: 'fresa, mora y arándanos',
    price: 1500,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_smo_alma',
    name: 'Smoothie Alma Verde',
    description: 'espinaca, pepino, apio, piña y miel de abeja',
    price: 1200,
    category: 'Bebidas',
    type: 'bebida',
  },
  // Gaseosas
  {
    id: 'beb_gas_coca',
    name: 'Coca Cola lata 237ml',
    price: 550,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_gas_fanta',
    name: 'Fanta naranja lata 237ml',
    price: 550,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_gas_sprite',
    name: 'Sprite lata 237ml',
    price: 550,
    category: 'Bebidas',
    type: 'bebida',
  },
  // Otras
  {
    id: 'beb_otr_agua_gas',
    name: 'Agua con gas Sparkling 503ml',
    price: 1000,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_otr_tropical',
    name: 'Tropical (variado) 250ml',
    price: 600,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_otr_agua',
    name: 'Botella de agua 500ml',
    price: 800,
    category: 'Bebidas',
    type: 'bebida',
  },
  // Calientes
  {
    id: 'beb_cal_aguadulce',
    name: 'Aguadulce en agua o leche',
    price: 900,
    category: 'Bebidas',
    type: 'bebida',
  },
  {
    id: 'beb_cal_chocolate',
    name: 'Chocolate caliente en agua o leche',
    price: 900,
    category: 'Bebidas',
    type: 'bebida',
  },
]
